<!--用水性质新增界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false" layout="vertical">
        <a-card>
          <a-row :gutter="16">
            <!-- <a-col :span="8">
              <a-form-item has-feedback label="价格编号">
                <a-input :disabled="disabled||isUsed" v-decorator="['wtCode', validatorRules.wtCode]" placeholder="请输入价格编号"></a-input>
              </a-form-item>
            </a-col> -->
            <a-col :span="8">
              <a-form-item has-feedback :label="$t('价格名称')">
                <a-input :disabled="disabled||isUsed" v-decorator="['wtName', validatorRules.wtName]" :placeholder="$t('请输入价格名称')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('阶梯数量')">
                <j-dict-select-tag :disabled="disabled||isUsed" @change="handleChange" v-decorator="['wtStepNum', validatorRules.wtStepNum]"  :triggerChange="true"
                :placeholder="$t('请选择阶梯数量')" dictCode="wt_step_num">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="stepNum<=1">
              <a-form-item :label="$t('基本水价')">
                <a-input :disabled="disabled||isUsed" v-decorator="['wtBasicPrice', validatorRules.wtBasicPrice]" :placeholder="$t('请输入基本水价(两位小数)')" :suffix="$t('元')" type="number" :step="0.1" style="width:100%" @change="changeWtBasicPrice" ref="wtBasicPrice"/>
              </a-form-item>
            </a-col>

            <a-col :span="8" v-if="stepNum>1">
              <a-form-item :label="$t('阶梯计费方式')">
                <j-dict-select-tag :disabled="disabled||isUsed" v-decorator="['wtStepCalWay', validatorRules.wtStepCalWay]" :triggerChange="true" :placeholder="$t('请选择计费方式')" dictCode="wt_step_cal_way"/>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="stepNum>1">
              <a-form-item :label="$t('阶梯计费起始日期')">
                <j-date :disabled="disabled||isUsed" :placeholder="$t('请选择阶梯计费起始日期')" v-decorator="['wtBeginDate', validatorRules.wtBeginDate]" :trigger-change="true" style="width:100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('计费类型')">
                <j-dict-select-tag :disabled="disabled||isUsed"  v-decorator="['wtFeeType', validatorRules.wtFeeType]" :triggerChange="true" :placeholder="$t('请选择计费类型')" dictCode="wt_fee_type"></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('附加费总计')">
                <a-input-number v-decorator="['wtTotalChargePrice',validatorRules.wtTotalChargePrice]" :placeholder="$t('请输入附加费总计')" disabled style="width:100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="stepNum<=1">
              <a-form-item :label="$t('水价总计')">
                <a-input v-decorator="['wtTotalPrice', validatorRules.wtTotalPrice]" :placeholder="$t('请输入单价总计')" :suffix="$t('元')" :step="0.1" disabled style="width:100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('禁用状态')">
                <j-dict-select-tag :disabled="disabled"  v-decorator="['statusDisable', validatorRules.statusDisable]" :triggerChange="true" :placeholder="$t('请选择')" dictCode="status_disable"></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <!--
            <a-col :span="8" v-if="stepNum>1">
              <a-form-item label="阶梯状态">
                <a-input-number v-decorator="['wtStepState',validatorRules.wtStepState]" placeholder="请输入阶梯状态" style="width:100%"/>
              </a-form-item>
            </a-col>
            -->
          </a-row> 
        </a-card>
      <h3 style="font-weight: bold;margin-top:10px" v-if="stepNum>1">{{ $t('阶梯水价') }}<samp style="color:red">*</samp></h3>
      <a-card>
        <a-row :gutter="16" v-if="stepNum>1">
          <a-col :span="6">    <!--阶梯水价表头 -->
            <a style="color:black">{{ $t('阶梯') }}</a>
          </a-col>
          <a-col :span="6">
            <a style="color:black">{{ $t('水量上限值(m³)') }}</a>
          </a-col>
          <a-col :span="6">
            <a style="color:black">{{ $t('单价(元)') }}</a>
          </a-col>
          <a-col :span="6">
            <a style="color:black">{{ $t('合计单价(元)') }}</a>
          </a-col>
        </a-row>
        <div v-if="stepNum>1">  <!--一阶水价-->
          <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item >
                  <a-input defaultValue="1" :readOnly="true"  class="background"/>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item>
                  <a-input :disabled="disabled||isUsed" v-decorator="['wtStep1Top',validatorRules.wtStep1Top]" :placeholder="$t('请输入一阶梯用水量上限')" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item>
                  <a-input :disabled="disabled||isUsed" v-decorator="['wtStep1BasePrice',validatorRules.wtStep1BasePrice]" :placeholder="$t('请输入一阶梯用水量价格')" @change="changePrice(1)" ref="wtStep1BasePrice" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item >
                  <a-input :disabled="disabled||isUsed" v-decorator="['wtStep1Price',validatorRules.wtStep1Price]" :readOnly="true" class="background"/>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
        <div v-if="stepNum>=2">  <!--二阶水价-->
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item >
                <a-input defaultValue="2" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum>2">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep2Top',validatorRules.wtStep2Top]"  :placeholder="$t('请输入二阶梯用水量上限')"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum==2">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep2Top',validatorRules.wtStep2Top]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep2BasePrice',validatorRules.wtStep2BasePrice]" :placeholder="$t('请输入二阶梯用水量价格')" @change="changePrice(2)" ref="wtStep2BasePrice"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep2Price',validatorRules.wtStep2Price]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div v-if="stepNum>=3">   <!--三阶水价-->
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item >
                <a-input defaultValue="3" :readOnly="true"  class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum>3">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep3Top',validatorRules.wtStep3Top]" :placeholder="$t('请输入三阶梯用水量上限')"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum==3">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep3Top',validatorRules.wtStep3Top]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep3BasePrice',validatorRules.wtStep3BasePrice]" :placeholder="$t('请输入三阶梯用水量价格')" @change="changePrice(3)" ref="wtStep3BasePrice" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep3Price',validatorRules.wtStep3Price]"  :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div v-if="stepNum>=4">   <!--四阶水价-->
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item >
                <a-input defaultValue="4" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum>4">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep4Top',validatorRules.wtStep4Top]" :placeholder="$t('请输入四阶梯用水量上限')"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum==4">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep4Top',validatorRules.wtStep4Top]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep4BasePrice',validatorRules.wtStep4BasePrice]" :placeholder="$t('请输入四阶梯用水量价格')" @change="changePrice(4)" ref="wtStep4BasePrice" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep4Price',validatorRules.wtStep4Price]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div v-if="stepNum>=5">   <!--五阶水价-->
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item >
                <a-input defaultValue="5" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum>5">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep5Top',validatorRules.wtStep5Top]" :placeholder="$t('请输入五阶梯用水量上限')"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="stepNum==5">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep5Top',validatorRules.wtStep5Top]" :readOnly="true" class="background"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item>
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep5BasePrice',validatorRules.wtStep5BasePrice]" :placeholder="$t('请输入五阶梯用水量价格')" @change="changePrice(5)" ref="wtStep5BasePrice" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item >
                <a-input :disabled="disabled||isUsed" v-decorator="['wtStep5Price',validatorRules.wtStep5Price]" :readOnly="true"  class="background"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <h3 style="font-weight: bold;margin-top:10px">{{ $t('参数') }}<samp style="color:red">*</samp></h3>  <!--参数配置 -->
      <a-card>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :label="$t('报警金额')">
              <a-input :disabled="disabled" v-decorator="['wtAlarmMoney',validatorRules.wtAlarmMoney]" :placeholder="$t('请输入提示报警金额')" :suffix="$t('元')" type="number" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('最大透支金额')">
              <a-input :disabled="disabled" v-decorator="['wtOverdrafTmoney',validatorRules.wtOverdrafTmoney]" :placeholder="$t('请输入最大透支金额')" :suffix="$t('元')" type="number" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('单次最大购买金额')">
              <a-input :disabled="disabled" v-decorator="['wtMaxBuyOnce',validatorRules.wtMaxBuyOnce]" :placeholder="$t('请输入单次最大购买金额')" :suffix="$t('元')" type="number" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('最大囤积金额')">
              <a-input :disabled="disabled" v-decorator="['wtMaxHording',validatorRules.wtMaxHording]" :placeholder="$t('请输入最大囤积金额')" :suffix="$t('元')" type="number" style="width:100%"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <div>
        <a-card :title="$t('表端计费参数')" style="width: 100%">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item :label="$t('磁干扰关阀是否开启')" >
                <a-select :disabled="disabled"  v-decorator="['wtCloseValveCigaorao',validatorRules.wtCloseValveCigaorao]" :placeholder="$t('请选择')">
                  <a-select-option :value="1">
                    {{ $t('是') }}
                  </a-select-option>
                  <a-select-option :value="0">
                    {{ $t('否') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('透支关阀是否开启')" >
                <a-select :disabled="disabled"  v-decorator="['wtCloseValveOverdraf',validatorRules.wtCloseValveOverdraf]" :placeholder="$t('请选择')">
                    <a-select-option :value="1">
                      {{ $t('是') }}
                    </a-select-option>
                    <a-select-option :value="0">
                      {{ $t('否') }}
                    </a-select-option>
                </a-select> 
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('欠压关阀是否开启')">
                <a-select :disabled="disabled" v-decorator="['wtCloseValveQianya',validatorRules.wtCloseValveQianya]" :placeholder="$t('请选择')">
                    <a-select-option :value="1">
                      {{ $t('是') }}
                    </a-select-option>
                    <a-select-option :value="0">
                      {{ $t('否') }}
                    </a-select-option>
                </a-select> 
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('报警关阀是否开启')">
                <a-select :disabled="disabled" v-decorator="['wtCloseValveAlarm',validatorRules.wtCloseValveAlarm]" :placeholder="$t('请选择')">
                    <a-select-option :value="1">
                      {{ $t('是') }}
                    </a-select-option>
                    <a-select-option :value="0">
                      {{ $t('否') }}
                    </a-select-option>
                </a-select> 
              </a-form-item>
            </a-col>
        </a-row>
      </a-card>
      </div>
      <h3 style="font-weight: bold;margin-top:10px">{{ $t('该价格名称费用项目') }}</h3>
      <h4 style="color:red;">{{ $t('请在下面列表勾选') }}</h4>
      <!--<j-form-container :disabled="!!model.id">-->
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="ipagination"
          :row-selection="rowSelection"
          rowKey='id'
          @change="handleTableChange"
          >
          <span slot="price" slot-scope="text, record">
            {{record.price|divideMoneyBy100Filter}}</span>
        </a-table>
        <!--
      </j-form-container>
      -->
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import {isUndefined, isNull,isUndefinedAndNull} from'@/utils/validate'
  import { duplicateCheck } from '@/api/api'
  import {divideMoneyBy100Filter} from '@/filters/moneyFilter.js'
  import { mapGetters } from 'vuex'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  import {IntegerWithZeroPattern} from '@/utils/regPattern'

const data = [];
  export default {
    name: 'MeterPriceinfoForm',
    filters: {divideMoneyBy100Filter},
    mixins:[JeecgListMixin],
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selectedRowKeys:[],   //table选中keys
        selectionRows:[],
        value:{},
        data,
        form: this.$form.createForm(this),
        model: {},

        confirmLoading: false,
        stepNum: 1,
        url: {
          list: "/jeecg-charge/meter/meterPriceItem/list",
          add: "/jeecg-charge/meter/meterPriceinfo/add",
          edit: "/jeecg-charge/meter/meterPriceinfo/edit",
          queryById: "/jeecg-charge/meter/meterPriceinfo/queryById",
          queryPrinceInfoByUserId:"/jeecg-charge/meter/meterPriceinfo/list"
        },
        disableMixinCreated: true,
        isUsed: false,
      }
    },
    computed: {
      columns() {
        return [
        {
          title: this.$t('项目代码'),
          dataIndex: 'priceId',
          align:"center",
        },{
          title: this.$t('项目名称'),
          dataIndex: 'priceName',
          align:"center",
        },{
          title: this.$t('收取方式'),
          dataIndex: 'priceWay',
          align:"center",
          customRender:(t,r,index) => {
            let data = {"1": this.$t("按量")}
            if(isUndefined(typeof data[t])) {
              return this.$t("其他")
            }
            return data[t]
          }
        },{
          title: this.$t('单价（元）'),
          dataIndex: 'price',
          align:"center",
          scopedSlots: { customRender: 'price' }
        },{
          title: this.$t('水费类型'),
          dataIndex: 'priceType',
          align:"center",
        },{
          title: this.$t('是否收取违约金'),
          dataIndex: 'hasPenalty',
          align:"center",
          customRender:(t,r,index) => {
            let data = {"0": this.$t("否"),"1":this.$t("是")}
            if(isUndefined(typeof data[t])) {
              return this.$t("其他")
            }
            return data[t]
          }
        },
      ]
      },
      validatorRules() {
        return {
          // wtCode: {  //价格编号
          //   rules: [
          //     { required: true, message: '请输入价格编号!'},
          //     {validator: this.validateWtCode}
          //   ]
          // },
          wtName: { //价格名称
            rules: [
              { required: true, message: this.$t('请输入价格名称!')},
              {validator: this.validateWtName}
            ],
          },
          wtBasicPrice: { // 基本单价
            rules: [
              { required: true, message: this.$t('请输入基本单价(两位小数)!')},
              {required: false,pattern: /^(([0-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[0-9]))$/,message: this.$t('基本单价有误(保留两位小数)')}
            ]
          },
          wtTotalPrice: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([0-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[0-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          wtStepNum: {  //阶梯数量
            initialValue:'1',
            rules: [
              { required: true, message: this.$t('请选择阶梯数量 总共支持5阶梯!')},
            ]
          },
          wtFeeType:{  // 计费类型
            rules:[
              {required: true, message:this.$t('请选择计费类型！')},
            ]
          },
          wtStepCalWay:{
            rules:[
              {required: true, message:this.$t('请选择阶梯计费方式！')}
            ]
          },
          wtBeginDate:{  //阶梯计费起始日期
            rules:[
              {required: true, message:this.$t('请选择阶梯计费起始日期！')},
            ]
          },
          wtAlarmMoney:{  //报警金额
            rules:[
              {required: true, message:this.$t('请输入报警金额！')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtOverdrafTmoney:{  //最大透支量
            rules:[
              {required: true, message:this.$t('请输入最大透支金额！')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtMaxBuyOnce:{   //最大购买金额
            rules:[

              {required: true, message:this.$t('请输入最大购买金额！')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtMaxHording:{   //最大囤积金额
            rules:[
              {required: true, message:this.$t('请输入最大囤积金额！')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtCloseValveCigaorao:{   //磁干扰关阀是否开启
            rules:[
              {required: true, message:this.$t('请选择磁干扰关阀是否开启！')},
            ]
          },
          wtCloseValveOverdraf:{   //透支关阀是否开启
            rules:[
              {required: true, message:this.$t('请选择透支关阀是否开启！')},
            ]
          },
          wtCloseValveQianya:{   //欠压关阀是否开启
            rules:[
              {required: true, message:this.$t('请选择欠压关阀是否开启！')},
            ]
          },
          wtCloseValveAlarm:{
            rules:[
              {required: true, message:this.$t('请选择报警关阀是否开启！')},
            ]
          },
          wtStep1Top: {
            rules:[
              {required: true,message: this.$t('请输入一阶水量上限')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtStep1BasePrice:{
            rules:[{required: true,message: this.$t('请输入一阶单价')},
            {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价有误(保留两位小数)')}
            ]
          },
          wtStep1Price: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          wtStep2BasePrice:{
            rules:[{required: true,message: this.$t('请输入二阶单价')},
            {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价有误(保留两位小数)')}
            ]
          },
          wtStep2Top: {
            rules:[
              {required: true,message: this.$t('请输入二阶水量上限')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtStep2Price: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          wtStep3Top: {
            rules:[
              {required: true,message: this.$t('请输入三阶水量上限')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtStep3BasePrice:{
            rules:[{required: true,message: this.$t('请输入三阶单价')},
            {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价有误(保留两位小数)')}
            ]
          },
          wtStep3Price: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          wtStep4Top: {
            rules:[
              {required: true,message: this.$t('请输入四阶水量上限')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtStep4BasePrice:{
            rules:[{required: true,message: this.$t('请输入四阶单价')},
            {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价有误(保留两位小数)')}
            ]
          },
          wtStep4Price: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          wtStep5Top: {
            rules:[
              {required: true,message: this.$t('请输入五阶水量上限')},
              {pattern: IntegerWithZeroPattern,message: this.$t('只支持正整数')},
              {validator: this.validateMax}
            ]
          },
          wtStep5BasePrice:{
            rules:[{required: true,message: this.$t('请输入五阶单价')},
            {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价有误(保留两位小数)')}
            ]
          },
          wtStep5Price: {  //单价总计
            rules: [
              { required: true, message: this.$t('请输入单价总计!')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9]))$/,message: this.$t('单价总计有误')},
              {validator: this.validatewtTotalPrice}
            ]
          },
          statusDisable: {  //阶梯数量
            initialValue:0,
            rules: [
              { required: true, message: this.$t('请选择禁用状态!')},
            ]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      rowSelection() {
        console.log("啦啦啦啦")
        return {
          onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          // TODO,选择框还是能选上
          getCheckboxProps: record => ({
            props: {
              disabled: this.disabled||this.isUsed, // Column configuration not to be checked
              name: record.priceName,
            },
          }),
          selectedRowKeys: this.selectedRowKeys
        };
      },
    },
    created () {
    },
    watch: {
      stepNum:{
        handler:function(newV,oldV){
          console.log("step变化")
          if(newV == 2) {
            this.validatorRules.wtStep2Top.rules[0].required = false
          }else if(newV == 3) {
            this.validatorRules.wtStep2Top.rules[0].required = true
            this.validatorRules.wtStep3Top.rules[0].required = false
          }else if(newV == 4){
            this.validatorRules.wtStep2Top.rules[0].required = true
            this.validatorRules.wtStep3Top.rules[0].required = true
            this.validatorRules.wtStep4Top.rules[0].required = false
          }else if(newV == 5){
            this.validatorRules.wtStep2Top.rules[0].required = true
            this.validatorRules.wtStep3Top.rules[0].required = true
            this.validatorRules.wtStep4Top.rules[0].required = true
            this.validatorRules.wtStep5Top.rules[0].required = false
          }
        }
      }
    },
    methods: {
      ...mapGetters(["userInfo"]),
      changeWtBasicPrice(e) {
        console.log(e)
        setTimeout(()=>{
          let wtTotalChargePrice = this.form.getFieldValue('wtTotalChargePrice')
          if(isUndefinedAndNull(wtTotalChargePrice)||wtTotalChargePrice=='') {
            wtTotalChargePrice = 0
          }
          console.log(this.$refs.wtBasicPrice.value)
          let wtBasicPrice = this.$refs.wtBasicPrice.value
          if(!isUndefinedAndNull(wtBasicPrice)&&wtBasicPrice!='') {
            this.form.setFieldsValue({wtTotalPrice:(parseFloat(wtTotalChargePrice)+parseFloat(wtBasicPrice)).toFixed(2)})
            this.form.validateFields(['wtTotalPrice'], {
              force: true
            });
          }else{
            this.form.setFieldsValue({wtTotalPrice:wtTotalChargePrice})
          }
        },400)
        
      },
      onSelectChange(selectedRowKeys, selectionRows) {  //获取table选中keys
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        let wtTotalChargePrice = 0;
        let te = this.$options.filters['divideMoneyBy100Filter']
        for(let i =0;i<this.selectionRows.length;i++) {
          wtTotalChargePrice+=this.selectionRows[i].price
        }
        this.form.setFieldsValue({wtTotalChargePrice: te(wtTotalChargePrice)})
        let wtBasicPrice = 0;
        if(!isUndefinedAndNull(this.form.getFieldValue('wtBasicPrice'))) {
          wtBasicPrice = this.form.getFieldValue('wtBasicPrice')
        }
        this.form.setFieldsValue({wtTotalPrice: (parseFloat(wtBasicPrice)+te(wtTotalChargePrice)).toFixed(2)})
        this.form.validateFields(['wtTotalPrice'], {
          force: true
        });
        // 设置阶梯价格
        let wtStep1BasePrice = this.form.getFieldValue('wtStep1BasePrice')
        let wtStep2BasePrice = this.form.getFieldValue('wtStep2BasePrice')
        let wtStep3BasePrice = this.form.getFieldValue('wtStep3BasePrice')
        let wtStep4BasePrice = this.form.getFieldValue('wtStep4BasePrice')
        let wtStep5BasePrice = this.form.getFieldValue('wtStep5BasePrice')
        if(!isUndefined(wtStep1BasePrice)) {
          this.form.setFieldsValue({wtStep1Price: (parseFloat(wtStep1BasePrice)+te(wtTotalChargePrice)).toFixed(2)})
        }
        if(!isUndefined(wtStep2BasePrice)) {
          this.form.setFieldsValue({wtStep2Price: (parseFloat(wtStep2BasePrice)+te(wtTotalChargePrice)).toFixed(2)})
        }
        if(!isUndefined(wtStep3BasePrice)) {
          this.form.setFieldsValue({wtStep3Price: (parseFloat(wtStep3BasePrice)+te(wtTotalChargePrice)).toFixed(2)})
        }
        if(!isUndefined(wtStep4BasePrice)) {
          this.form.setFieldsValue({wtStep1Price: (parseFloat(wtStep4BasePrice)+te(wtTotalChargePrice)).toFixed(2)})
        }
        if(!isUndefined(wtStep5BasePrice)) {
          this.form.setFieldsValue({wtStep1Price: (parseFloat(wtStep5BasePrice)+te(wtTotalChargePrice)).toFixed(2)})
        }
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.loadData(1);
        console.log(!!this.model.id);
        if (this.model.id) {
          // 设置附加不能修改
          /*
          this.rowSelection.getCheckboxProps = (record) => ({
            props: {
              disabled: true, // Column configuration not to be checked
            },
          }),
          */
          this.stepNum = record.wtStepNum
          this.model.wtTotalPrice = this.divideMoneyBy100(record.wtTotalPrice);
          this.model.wtTotalChargePrice = this.divideMoneyBy100(record.wtTotalChargePrice);
          this.model.wtStep1Price = this.divideMoneyBy100(record.wtStep1Price);  //一阶价格
          this.model.wtStep2Price = this.divideMoneyBy100(record.wtStep2Price);  //二阶价格
          this.model.wtStep3Price = this.divideMoneyBy100(record.wtStep3Price);  //三阶价格
          this.model.wtStep4Price = this.divideMoneyBy100(record.wtStep4Price);  //四阶价格
          this.model.wtStep5Price = this.divideMoneyBy100(record.wtStep5Price);  //五阶价格
          this.model.wtAlarmMoney = record.wtAlarmMoney;  //报警金额
          this.model.wtOverdrafTmoney = record.wtOverdrafTmoney;  //最大透支量
          this.model.wtMaxBuyOnce = record.wtMaxBuyOnce;  //最大购买金额
          this.model.wtMaxHording = record.wtMaxHording;  //最大囤积值
          this.selectedRowKeys = (record.wtPriceItemList || '').split(',');  //返回的字符串类型转换为数组 
        }
        this.$nextTick(() => {
          if(this.model.wtStepNum<=1) {
              this.form.setFieldsValue(pick(this.model,'wtCode','wtName','wtBasicPrice','wtTotalPrice','wtFeeType','statusDisable','wtStepNum','wtTotalChargePrice','wtAlarmMoney','wtMaxBuyOnce','wtOverdrafTmoney','wtMaxHording','wtCloseValveOverdraf','wtCloseValveCigaorao','wtCloseValveQianya','wtCloseValveAlarm'))
            }else{
              this.form.setFieldsValue(pick(this.model,'wtCode','wtName','wtFeeType','statusDisable','wtStepCalWay','wtStepNum','wtTotalChargePrice','wtAlarmMoney','wtMaxBuyOnce','wtOverdrafTmoney','wtMaxHording','wtCloseValveOverdraf','wtCloseValveCigaorao','wtCloseValveQianya','wtCloseValveAlarm'))
              
            }
            if(!isUndefinedAndNull(this.model.wtStepNum)&&this.model.wtStepNum!='') {
            console.log("啦啦啦")
            let wtTotalChargePrice = 0
            if(!isUndefinedAndNull(this.model.wtTotalChargePrice)) {
              wtTotalChargePrice = this.model.wtTotalChargePrice
            }
            if(this.model.wtStepNum>1) {
              //this.form.setFieldsValue({wtStepCalWay: this.model.wtStepCalWay})
              this.form.setFieldsValue({wtBeginDate: this.model.wtBeginDate})
              this.form.setFieldsValue({wtStepState: this.model.wtStepState})
              console.log("大于一阶")
              this.form.setFieldsValue({wtStep1Top: this.model.wtStep1Top})
              this.form.setFieldsValue({wtStep1Price: this.model.wtStep1Price})
              this.form.setFieldsValue({wtStep2Price: this.model.wtStep2Price})

              if(!isUndefinedAndNull(record.wtStep1Price)&&record.wtStep1Price!='') {
                this.form.setFieldsValue({wtStep1BasePrice: (this.model.wtStep1Price - wtTotalChargePrice).toFixed(2)})
              }
              if(!isUndefinedAndNull(record.wtStep2Price)&&record.wtStep2Price!='') {
                this.form.setFieldsValue({wtStep2BasePrice: (this.model.wtStep2Price - wtTotalChargePrice).toFixed(2)})
              }
              
            }
            if(this.model.wtStepNum>2){
              this.form.setFieldsValue({wtStep2Top: this.model.wtStep2Top})
              this.form.setFieldsValue({wtStep3Price: this.model.wtStep3Price})
              if(!isUndefinedAndNull(record.wtStep3Price)&&record.wtStep3Price!='') {
                this.form.setFieldsValue({wtStep3BasePrice: (this.model.wtStep3Price - wtTotalChargePrice).toFixed(2)})
              }
            }
            if(this.model.wtStepNum>3){
              this.form.setFieldsValue({wtStep3Top: this.model.wtStep3Top})
              this.form.setFieldsValue({wtStep4Price: this.model.wtStep4Price})
              if(!isUndefinedAndNull(record.wtStep4Price)&&record.wtStep4Price!='') {
                this.form.setFieldsValue({wtStep4BasePrice: (this.model.wtStep4Price - wtTotalChargePrice).toFixed(2)})
              }
            }
            if(this.model.wtStepNum>4){
              this.form.setFieldsValue({wtStep4Top: this.model.wtStep4Top})
              this.form.setFieldsValue({wtStep5Price: this.model.wtStep5Price})
              if(!isUndefinedAndNull(record.wtStep5Price)&&record.wtStep5Price!='') {
                this.form.setFieldsValue({wtStep5BasePrice: (this.model.wtStep5Price - wtTotalChargePrice).toFixed(2)})
              }
            }
            console.log(this.model.wtTotalPrice)
            if(!isUndefinedAndNull(this.model.wtTotalPrice)&&this.model.wtTotalPrice!='') {
              console.log("设置基本水价")
              this.form.setFieldsValue({wtBasicPrice: (this.model.wtTotalPrice - wtTotalChargePrice).toFixed(2)})
            }
          }
        })
      },
      divideMoneyBy100(data) {    //判断显示分转元的方法
        if(isUndefined(data)||isNull(data)||data==='') {
          return ''
        }
        return (parseFloat(data)/100).toFixed(2)
      },
      divideMoney100(data) {   //判断显示元转分的方法
        if(isUndefined(data) || isNull(data) || data === '') {
          return ''
        } 
        return (parseFloat(data)*100).toFixed(0)
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log(values)
            formData.wtTotalChargePrice = this.divideMoney100(formData.wtTotalChargePrice);   //附加费总计
            formData.wtStep1Price = this.divideMoney100(formData.wtStep1Price); //一阶价格
            formData.wtStep2Price = this.divideMoney100(formData.wtStep2Price); //二阶价格
            formData.wtStep3Price = this.divideMoney100(formData.wtStep3Price); //三阶价格
            formData.wtStep4Price = this.divideMoney100(formData.wtStep4Price); //四阶价格
            formData.wtStep5Price = this.divideMoney100(formData.wtStep5Price); //五阶价格
            if(formData.wtStepNum>1) {
              formData.wtTotalPrice = formData.wtStep1Price; //单价总计
            }else{
              formData.wtTotalPrice = this.divideMoney100(formData.wtTotalPrice); //单价总计
            }
            formData.wtAlarmMoney = this.model.wtAlarmMoney;  //报警金额
            formData.wtOverdrafTmoney = this.model.wtOverdrafTmoney;  //最大透支量
            formData.wtMaxBuyOnce = this.model.wtMaxBuyOnce;  //最大购买金额
            formData.wtMaxHording = this.model.wtMaxHording;  //最大囤积值
            if (this.selectedRowKeys.length>0) {
            formData.wtPriceItemList = this.selectedRowKeys.join(',');   //传table选中keys的数组并将数组转化为字符串
            }
            console.log(this.selectedRowKeys);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          } 
        })
      },
      handleChange(value) {
        this.stepNum = value
      },
      shut(){    //关闭事件
        this.stepNum = 1
        this.selectedRowKeys = [];
        this.form.resetFields();
      },
      changePrice(stepNum){
        setTimeout(()=> {
          let wtTotalChargePrice = this.form.getFieldValue('wtTotalChargePrice')
          if(isUndefinedAndNull(wtTotalChargePrice)) {
            wtTotalChargePrice = 0
          }
          if(stepNum == 1) {
            let wtStep1BasePrice = this.$refs.wtStep1BasePrice.value
            if(!isUndefinedAndNull(wtStep1BasePrice)) {
              this.form.setFieldsValue({wtStep1Price: (parseFloat(wtStep1BasePrice)+parseFloat(wtTotalChargePrice)).toFixed(2)})
            }else{
              this.form.setFieldsValue({wtStep1Price: ''})
            }
          }else if(stepNum == 2) {
            let wtStep2BasePrice = this.$refs.wtStep2BasePrice.value
            if(!isUndefinedAndNull(wtStep2BasePrice)) {
              this.form.setFieldsValue({wtStep2Price: (parseFloat(wtStep2BasePrice)+parseFloat(wtTotalChargePrice)).toFixed(2)})
            }else{
              this.form.setFieldsValue({wtStep2Price: ''})
            }
          }else if(stepNum == 3) {
            let wtStep3BasePrice = this.$refs.wtStep3BasePrice.value
            if(!isUndefinedAndNull(wtStep3BasePrice)) {
              this.form.setFieldsValue({wtStep3Price: (parseFloat(wtStep3BasePrice)+parseFloat(wtTotalChargePrice)).toFixed(2)})
            }else{
              this.form.setFieldsValue({wtStep3Price: ''})
            }
          }else if(stepNum == 4) {
            let wtStep4BasePrice = this.$refs.wtStep4BasePrice.value
            if(!isUndefinedAndNull(wtStep4BasePrice)) {
              this.form.setFieldsValue({wtStep4Price: (parseFloat(wtStep4BasePrice)+parseFloat(wtTotalChargePrice)).toFixed(2)})
            }else{
              this.form.setFieldsValue({wtStep4Price: ''})
            }
          }
          else if(stepNum == 5) {
            let wtStep5BasePrice = this.$refs.wtStep5BasePrice.value
            if(!isUndefinedAndNull(wtStep5BasePrice)) {
              this.form.setFieldsValue({wtStep5Price: (parseFloat(wtStep5BasePrice)+parseFloat(wtTotalChargePrice)).toFixed(2)})
            }else{
              this.form.setFieldsValue({wtStep5Price: ''})
            }
          }
        },400)
        
      },
      // 查询价格名称是否重复
      validateWtName(rule, value, callback) {
        if(isUndefined(value)||value === '') {
          callback()
          return
        }
        let org = this.userInfo().orgCode
        if(org.length>3){
          org = org.substr(0,3)
        }
        let wtName = this.form.getFieldValue('wtName').trim();
        this.form.setFieldsValue({wtName: wtName});
        let params = {wtName: wtName,sysOrgCode: org+'*'}
        getAction(this.url.queryPrinceInfoByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该价格名称已存在!"))
            }
          } else {
            callback()
          }
        })
      },
      validatewtTotalPrice(rule, value, callback) {
        if(isUndefined(value)||value=== '') {
          callback()
          return
        }
        if(parseFloat(value)>600) {
          callback(this.$t("水费总计不能超过600!"))
        }
        callback()
      },
      validateMax(rule, value, callback) {
        if(isUndefined(value) === '') {
          callback()
          return
        }
        if(parseFloat(value)>999999) {
          callback(this.$t("不能超过999999!"))
        }
        callback()
      },
      // 查询价格编码是否重复
      validateWtCode(rule, value, callback) {
        if(isUndefined(value)||value === '') {
          callback()
          return
        }
        let org = this.userInfo().orgCode
        if(org.length>3){
          org = org.substr(0,3)
        }
        let wtCode = this.form.getFieldValue('wtCode').trim();
        this.form.setFieldsValue({wtCode: wtCode});
        let params = {wtCode: wtCode,sysOrgCode: org+'*'}
        getAction(this.url.queryPrinceInfoByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该价格编码已存在!"))
            }
          } else {
            callback()
          }
        })
      },
    }
  }
</script>
<style >
</style>